import React from "react";
import { Badge, Card, CardContent } from "@material-ui/core";
import styles from "../clients.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import {
  Building,
  Edit,
  Users,
  Calendar,
  Clock,
  Save,
} from "lucide-react";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import { useMediaQuery } from "@mui/material";
import { Button } from "../../../components/ui/button";

const Step5 = (props) => {
  const { stepContentValues, onCancelAll, loading, setDisplayStep } = props;

  const isMobile = useMediaQuery("(max-width:767px)");

  const validateAndGoNext = () => {
    props?.validateAndGoNext &&
      props?.validateAndGoNext(null, { finalsubmit: true });
  };

  return (
    <>
      <Card className={`${styles.card} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
        <CardContent className={styles.cardContent}>
          <div className="d-flex flex-center flex-space-between mb-24">
            <h2
              className="d-flex flex-center text-foreground"
              style={{ fontSize: "20px", fontWeight: "600" }}
            >
              <Users className="h-5 w-5 mr-10 color-primary" />
              Client Profile Summary
            </h2>
          </div>

          <div className={`${styles.gridLayout} mv-20`}>
            <div className={styles.column}>
              <section className="mb-24">
                <div className="d-flex flex-center flex-space-between mb-4">
                  <h3
                    className="d-flex flex-center m-0 text-foreground"
                    style={{ fontSize: "20px", fontWeight: "500" }}
                  >
                    <Building className="h-4 w-4 mr-10 text-gray-500" />
                    General Information
                  </h3>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setDisplayStep(1)}
                    className="flex items-center gap-1.5 color-primary hover:text-primary hover:bg-primary/5"
                  >
                    <Edit className="h-3.5 w-3.5 mr-4" />
                    <span>Edit</span>
                  </Button>
                </div>

                <div
                  style={{ borderRadius: "8px" }}
                  className="p-20 bg-[#F9FAFB] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                >
                  <dl className={styles.clientInfolist}>
                    <div className={styles.clientInfoItem}>
                      <dt className={styles.clientInfoLabel}>Company</dt>
                      <div className={`dark:text-white ${styles.clientInfoValue}`}>
                        {stepContentValues?.stepContent?.clientName ||
                          "Not specified"}
                      </div>
                    </div>

                    <div className={styles.clientInfoItem}>
                      <dt className={styles.clientInfoLabel}>Address</dt>
                      <div className={`dark:text-white ${styles.clientInfoValue}`}>
                        {stepContentValues?.stepContent?.addressInfo?.city}
                      </div>
                    </div>

                    <div className={styles.clientInfoItem}>
                      <dt className={styles.clientInfoLabel}>TimeZone</dt>
                      <div className={`dark:text-white ${styles.clientInfoValue}`}>
                        {stepContentValues?.stepContent?.timeZone ||
                          "No TimeZone provided"}
                      </div>
                    </div>

                    <div className={styles.clientInfoItem}>
                      <dt className={styles.clientInfoLabel}>Industry</dt>
                      <div className={`dark:text-white ${styles.clientInfoValue}`}>
                        {stepContentValues?.stepContent?.industryType ||
                          "No phone provided"}
                      </div>
                    </div>

                    <div className={styles.clientInfoItem}>
                      <dt className={styles.clientInfoLabel}>
                        Reports Frequency
                      </dt>
                      <div className={`dark:text-white ${styles.clientInfoValue}`}>
                        {stepContentValues?.stepContent
                          ?.summaryReportFrequency || "Not specified"}
                      </div>
                    </div>
                  </dl>
                </div>
              </section>
              <section className="mb-24">
                <div className="d-flex flex-center flex-space-between mb-16">
                  <h3
                    className="d-flex flex-center text-foreground"
                    style={{ fontSize: "18px", fontWeight: "600" }}
                  >
                    <Users className="h-5 w-5 mr-10 color-Grays" />
                    Contacts
                  </h3>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setDisplayStep(2)}
                    className="flex items-center gap-1.5 color-primary hover:text-primary hover:bg-primary/5"
                  >
                    <Edit className="h-3.5 w-3.5 mr-4" />
                    <span>Edit</span>
                  </Button>
                </div>

                {stepContentValues?.contact &&
                (stepContentValues?.contact?.primary?.length > 0 ||
                  stepContentValues?.contacts?.additional?.length > 0) ? (
                  <div
                    style={{
                      // border: "1px solid #ddd",
                      // borderRadius: "8px",
                      overflow: "hidden",
                    }}
                    className="dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                  >
                    {stepContentValues?.contact?.primary?.map((contact) => (
                      <div
                        className="p-16"
                        style={{ borderBottom: "1px solid #eee" }}
                      >
                        <div
                          className={
                            isMobile
                              ? "d-flex flex-direction-column"
                              : "d-flex flex-space-between flex-center"
                          }
                        >
                          <div
                            className={
                              isMobile
                                ? "d-flex flex-center flex-justify-start"
                                : "d-flex flex-center flex-justify-center"
                            }
                          >
                            <span className={`${styles.avatarNew} mr-12`}>
                              {contact.name.charAt(0).toUpperCase()}
                            </span>
                            <div>
                              <p
                                style={{ fontWeight: "500", gap: "8px" }}
                                className="d-flex flex-center mv-0 dark:text-white"
                              >
                                {contact.name}
                                <span
                                  className="ml-5 p-5"
                                  style={{
                                    backgroundColor: "#FFFBEB",
                                    color: "#B45309",
                                    fontSize: "12px",
                                    borderRadius: "20px",
                                    border: "1px solid rgb(253 230 138 / 1)",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faCrown}
                                    fontSize={"small"}
                                  />{" "}
                                  Primary
                                </span>
                              </p>
                              <p className={styles.contactEmail}>
                                {contact?.email}
                              </p>
                            </div>
                          </div>
                          <div className={styles.phoneInfo}>
                            <CallOutlinedIcon className={styles.phoneIcon} />
                            <span className="dark:text-white">{contact?.mobileNumber}</span>
                          </div>
                        </div>
                      </div>
                    ))}

                    {stepContentValues?.contact?.additional?.map((contact) => (
                      <div className="p-16" style={{ borderBottom: "1px solid #eee" }}>
                        <div className={isMobile  ? "d-flex flex-direction-column"  : "d-flex flex-space-between flex-center"}>
                        <div className="d-flex flex-center flex-justify-center">
                          <div className={"mr-12"}>
                            <span className={styles.avatarNew}>
                              {contact.name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div style={{ flexGrow: "1" }}>
                            <p
                              style={{ fontWeight: "500", gap: "8px" }}
                              className="d-flex flex-center text-foreground"
                            >
                              {contact.name}
                            </p>
                            <p className={styles.contactEmail}>
                              {contact.email}
                            </p>
                          </div>
                        </div>
                        {contact?.mobileNumber && (
                          <div className={styles.phoneInfo}>
                            <CallOutlinedIcon className={styles.phoneIcon} />
                            <span className="dark:text-white">{contact?.mobileNumber}</span>
                          </div>
                        )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={`${styles.emptyCard} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
                    <p className="dark:text-white">No contacts added</p>
                  </div>
                )}
              </section>
            </div>

            <div className={styles.column}>
              <section className="mb-16">
                <div className="d-flex flex-center flex-space-between mb-16">
                  <h3
                    className="d-flex flex-center text-foreground"
                    style={{ fontSize: "18px", fontWeight: "500" }}
                  >
                    <Clock className="h-4 w-4 mr-10 color-Grays" />
                    Shifts
                  </h3>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setDisplayStep(3)}
                    className="flex items-center gap-1.5 color-primary hover:text-primary hover:bg-primary/5"
                  >
                    <Edit className="h-3.5 w-3.5 mr-4" />
                    <span>Edit</span>
                  </Button>
                </div>

                {stepContentValues?.shiftsList &&
                stepContentValues?.shiftsList.length > 0 ? (
                  <div
                    className="d-flex flex-direction-column"
                    style={{ gap: "10px" }}
                  >
                    {stepContentValues?.shiftsList.map((shift) => (
                      <div key={shift.shiftId} className={`${styles.shiftItem} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                        <div className={styles.shiftItemContent}>
                          <div>
                            <p className={`${styles.shiftName} dark:text-white`}>{shift?.title}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={`${styles.noShifts} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
                    <p className={styles.noShiftsText}>No shifts added</p>
                  </div>
                )}
              </section>

              <section className="mb-16">
                <div className="d-flex flex-center flex-space-between mb-16">
                  <h3
                    className="d-flex flex-center text-foreground"
                    style={{ fontSize: "18px", fontWeight: "500" }}
                  >
                    <Calendar className="h-4 w-4 mr-10 color-Grays" />
                    Tasks
                  </h3>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setDisplayStep(1)}
                    className="flex items-center gap-1.5 color-primary hover:text-primary hover:bg-primary/5"
                  >
                    <Edit className="h-3.5 w-3.5 mr-4" />
                    <span>Edit</span>
                  </Button>
                </div>

                {stepContentValues?.SummaryList &&
                stepContentValues?.SummaryList.some(
                  (summary) => summary.tasks && summary.tasks.length > 0
                ) ? (
                  <div className={`${styles.shiftItem} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                    {stepContentValues?.SummaryList?.map((summary, index) => {
                      const shift = stepContentValues?.shiftsList?.find(
                        (s) => s.shiftId === summary.shift.shiftId
                      );

                      return (
                        <div
                          key={summary.id}
                          style={{
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom:
                              index !== stepContentValues?.SummaryList?.length - 1
                                ? "1px solid #e5e7eb"
                                : "none",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "16px",
                              marginBottom: "10px",
                            }}
                            className="text-[#111827] dark:text-white"
                          >
                            {shift ? shift.title : "Unnamed Shift"}
                          </p>

                          <div className="d-flex flex-direction-column" style={{ gap: "8px" }}>
                            {summary?.tasks
                              ?.filter((task) => task?.title?.trim())
                              .map((task) => (
                                <div
                                  key={task.taskId}
                                  className="d-flex flex-space-between flex-center"
                                >
                                  <p
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      paddingLeft: "8px",
                                    }}
                                    className="text-[#020817] dark:text-[#6B7280]"
                                  >
                                    {task?.title}
                                  </p>
                                  <Badge
                                    variant="outline"
                                    style={{
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "40px",
                                      padding: "4px 10px",
                                      fontSize: "12px",
                                    }}
                                    className="text-[#020817] dark:text-[#6B7280]"
                                  >
                                    {summary?.frequency}
                                  </Badge>
                                </div>
                              ))}
                          </div>
                        </div>
                      );
                    })}
                    {/* {stepContentValues?.customTaskList &&
                      Object.entries(stepContentValues.customTaskList).map(
                        ([taskId, task]) => {
                          const shift = stepContentValues?.shiftsList?.find(
                            (s) => s.shiftId === task.shift
                          );

                          return (
                            <div key={taskId} className={styles.shiftTaskItem}>
                              <div className="d-flex flex-direction-column">
                                <div className="d-flex flex-space-between flex-center mt-12">
                                  <p
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "14px",
                                    }}
                                    className="text-[#020817] dark:text-[#6B7280]"
                                  >
                                    {task?.title}
                                  </p>
                                  <Badge
                                    variant="outline"
                                    style={{
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "40px",
                                      padding: "5px",
                                    }}
                                    className="text-[#020817] dark:text-[#6B7280]"
                                  >
                                    {task?.frequency}
                                  </Badge>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )} */}
                  </div>
                ) : (
                  <div
                    className="p-12 text-center bg-[#F9FAFB] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                    style={{ borderRadius: "8px"}}
                  >
                    <p style={{ fontSize: "14px", color: "#6B7280" }}>
                      No tasks added
                    </p>
                  </div>
                )}
              </section>

              <div className={`${styles.clientSummary} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                <Users className={styles.clientSummaryIcon} />
                <p className={styles.clientSummaryText}>
                  This client has{" "}
                  {(stepContentValues?.contact?.primary?.length || 0) +
                    (stepContentValues?.contact?.additional?.length || 0)}{" "}
                  contact
                  {(stepContentValues?.contact?.primary?.length || 0) +
                    (stepContentValues?.contact?.additional?.length || 0) !==
                  1
                    ? "s"
                    : ""}{" "}
                  and {stepContentValues?.shiftsList?.length || 0} shift
                  {stepContentValues?.shiftsList?.length !== 1 ? "s" : ""}{" "}
                  configured.
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="buttonsWrap d-flex flex-center flex-space-between mv-20">
        <DialogComponent
          buttonWrapClassName="d-inline"
          buttonClassName="bg-white dark:bg-gray-800"
          buttonProps={{
          variant: "outline",
          disabled: loading,
          }}
          buttonLabel={"Cancel"}
          ModalTitle={"Are you sure you want to cancel this entry?"}
          ModalContent={<ConfirmCancel onCancelAll={onCancelAll} />}
        />
        <Button
          color="primary"
          variant="contained"
          className={isMobile  ? "ml-15 bg-green color-white" : "w-full sm:w-auto mr-15 bg-green color-white"}
          onClick={() => validateAndGoNext()}
          disabled={loading === true ? true : false}
        >
          <Save className="mr-2 h-4 w-4" />{" "}
          {loading === true
            ? "Loading..."
            : props?.editData !== false
            ? "Update"
            : "Submit"}
        </Button>
      </div>
    </>
  );
};

export default Step5;
